import { Table } from '@kanda-libs/ks-component-ts';

import useRateRequestTableProps from './useRateRequestTableProps';

export interface RateRequestTableProps {}

const RateRequestTable: React.FunctionComponent<RateRequestTableProps> =
  function ({}) {
    const tableProps = useRateRequestTableProps();
    return (
      <div className="-mx-8">
        <Table {...tableProps} />
      </div>
    );
  };

export default RateRequestTable;
